function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M92.2502+276.991L82.1082+257.116L74.8346+250.56L67.476+241.564L67.0438+226.153L68.1522+206.359L80.5824+194.087L100.851+194.246L111.692+185.833L122.782+139.329L134.293+105.995L154.676+95.4436L160.388+78.117L189.448+66.4269L220.141+69.5201L290.205+122.195L311.511+143.405L320.623+166.667L334.053+183.693L336.93+207.434L322.936+226.506L335.013+226.845L359.221+248.167L356.906+272.283L351.034+289.536L335.155+294.815L316.12+292.029L290.933+301.199L220.702+307.288L156.563+308.011L130.786+318.855L109.099+317.557L102.132+303.115L82.5301+300.862L74.6418+290.509L92.2502+276.991Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M74.8813+282.361L85.5212+265.832L100.375+255.541L108.739+234.033L104.511+237.342L118.55+215.908L116.8+211.494L124.602+182.809L144.487+170.659L166.638+148.149L189.291+141.377L219.748+136.397L239.885+153.528L254.484+175.24L269.838+198.944L279.939+216.465L279.534+220.017L284.437+235.596L290.821+249.877L307.914+276.978L304.317+303.357L263.298+326.865L232.076+332.844L201.007+355.762L150.366+335.833L138.815+326.261L124.902+324.268L108.27+329.198L91.0261+332.034L86.8244+326.827L85.6478+330.004L79.6726+323.735L70.9022+306.756L69.2434+308.306L76.9972+281.372L74.8813+282.361Z",
  fill: "#000000",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M278.509+110.723L291.526+99.8865L302.419+101.45L304.225+104.268L303.448+107.686L307.162+108.849L309.237+112.086L307.077+127.228L298.195+138.423L298.656+148.451L294.391+156.058L287.936+155.021L278.862+125.378L278.509+110.723Z",
  fill: "#000000",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M177.218+127.818L197.724+106.317L215.546+85.8779L211.175+86.2785L234.072+76.4623L256.495+76.2398L254.719+70.6202L258.574+76.5798L262.572+71.8402L260.328+76.5145L265.247+75.6231L262.01+77.8994L282.089+87.9486L279.097+87.9448L289.89+119.693L288.546+123.06L292.68+133.15L293.323+152.901L295.348+161.405L293.143+158.076L291.287+171.526L287.305+175.212L285.07+186.836L279.254+188.634L278.67+198.076L268.31+217.697L243.452+200.473L188.578+204.836L153.477+159.712L177.218+127.818Z",
  fill: "#000000",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M211.559+94.8342L203.8+88.0871L195.198+84.3646L180.165+93.9315L178.116+102.706L174.172+110.068L181.779+128.165L183.854+138.208L187.248+147.382L192.166+153.826L201.007+155.033L206.815+149.604L209.863+139.13L207.26+130.444L212.324+123.496L209.449+123.311L214.608+118.258L211.559+94.8342Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M263.277+113.208L256.945+119.179L254.6+133.647L241.468+139.848L240.765+150.641L247.8+157.531L256.007+172.228L266.795+179.807L278.52+171.769L282.457+157.014L279.529+147.244L281.712+138.823L273.361+126.987L263.277+113.208Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M102.515+157.069L97.1262+156.439L91.9618+158.447L91.1061+165.128L92.8998+170.159L98.0589+179.805L102.525+181.289L110.722+181.182L120.571+181.182L102.515+157.069Z",
  fill: "#000000",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M170.052+149.261L155.747+127.904L141.991+116.654L126.434+111.828L114.221+115.489L107.421+120.261L106.78+116.011L106.499+120.992L100.737+118.541L105.654+121.886L96.4174+136.86L101.107+161.203L116.585+179.575L126.434+199.784L143.553+211.496L168.41+198.636L170.052+149.261Z",
  fill: "#000000",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M147.539+127.444L149.369+115.26L154.81+112.03L163.551+113.971L168.41+122.163L169.185+127.96L168.645+138.008L162.548+149.032L156.685+139.386L157.54+132.513L154.537+134.316L147.539+127.444Z",
  fill: "#000000",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M118.764+151.515L118.93+158.906L119.136+168.273L122.213+176.36L129.014+185.546L135.595+185.091L139.801+181.182L137.456+170.389L137.673+166.589L142.146+161.433L142.531+156.365L140.035+152.017L131.124+151.328L124.742+148.592L118.764+151.515Z",
  fill: "#000000",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M201.007+257.342L203.669+252.935L208.444+250.731L207.434+246.508L228.551+241.641L261.512+243.753L260.411+256.974L248.199+270.471L235.988+274.878L217.9+268.635L213.952+263.218L209.178+263.218L208.26+260.188L211.841+258.811L210.647+256.056L206.883+255.965L204.863+258.168L201.007+257.342Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M203.568+260.957L187.18+253.901L173.685+254.235L168.744+260.204L172.312+266.338L190.517+271.468L202.85+274.333L206.227+268.054L203.568+260.957Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M191.564+273.574L172.937+267.463L164.261+269.944L163.97+276.04L178.558+283.691L188.074+284.371L192.256+279.168L191.564+273.574Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M166.251+280.311L163.013+283.89L163.524+289.599L171.96+293.348L181.674+287.98L181.418+285.168L176.561+284.657L166.251+280.311Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M182.623+252.998L191.883+242.561L200.123+241.933L203.105+248.211L201.007+253.391L195.101+256.53L187.489+253.469L182.623+252.998Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M274.632+218.671L309.253+192.151L310.307+186.386L314.773+186.565L316.452+183.32L320.863+181.061L319.798+185.662L322.16+188.315L317.114+190.603L313.422+194.625L310.85+193.504L275.398+220.88L274.632+218.671Z",
  fill: "#000000",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M289.703+247.751L313.427+239.82L314.342+241.225L315.926+239.734L326.861+247.5L330.084+246.725L332.602+249.2L335.333+249.797L337.21+251.205L336.271+253.766L333.37+254.192L332.986+256.198L330.255+253.595L327.652+254.235L326.627+249.029L314.183+241.552L290.533+249.257L289.703+247.751Z",
  fill: "#000000",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M334.575+271.112L339.408+266.064",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M295.174+229.919L301.754+228.744",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M78.1584+219.207L87.558+213.332",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M95.9037+280.207L104.363+291.956",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M98.1806+166.891L101.004+173.108L107.556+175.374",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M132.571+161.782L131.563+160.254L127.89+160.601L127.672+164.021L130.398+165.273L131.758+164.709",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M159.618+128.171L155.075+127.754L153.152+117.897L158.347+117.761L163.738+124.835",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M164.404+131.797L163.642+136.92",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M200.734+126.583L198.094+122.022L201.304+116.257L200.363+99.0068L195.198+92.2432",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M195.198+98.4575L188.392+100.445L186.247+108.174L182.89+112.33L188.78+123.2L190.075+132.007",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M197.648+133.088L200.807+139.459L198.111+146.476",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M293.515+113.594L297.213+110.128L300.657+116.46L289.534+137.506",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M257.191+147.965L255.067+144.106L251.069+144.743L249.751+148.2L251.707+151.627L255.237+151.753",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M261.936+132.8L265.985+128.862",
  fill: "none",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M229.396+259.453L226.613+262.853",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M251.593+247.457L244.174+248.137",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M194.77+262.359L192.668+265.203L193.533+268.356",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M183.207+258.216L180.239+264.708",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M177.148+274.354L178.323+278.62",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M194.002+252.213L190.235+251.115",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M168.263+92.0906L161.987+101.219",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M267.68+157.835L272.605+159.7",
  fill: "#000000",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M157.463+135.655L160.333+138.381L163.38+133.235L164.708+130.993L165.282+138.453L168.295+127.98L168.367+138.74L162.628+148.208L156.244+139.385L157.463+135.655Z",
  fill: "#000000",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M254.56+114.05L254.56+107.581L250.365+105.951L244.154+109.831L230.794+113.066L224.219+117.986L224.261+122.69L225.749+123.664L226.978+130.465L231.497+135.426L242.325+132.894L247.247+126.285L240.075+126.707L234.173+121.976L235.857+120.66L245.138+120.941L251.335+118.735L254.56+114.05Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M265.802+109.479L266.653+114.607L270.685+119.155L277.359+120.085L284.305+123.222L282.378+118.806L277.568+112.706L273.005+111.092L269.565+107.912L265.802+109.479Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
}));

function SvgTroll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTroll);
export default __webpack_public_path__ + "static/media/troll.bab6f55b.svg";
export { ForwardRef as ReactComponent };